import React, { useRef } from 'react';
import {
  Box,
  Grid,
  Typography,
  Stack,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { SharePopup } from './SharePopup';
import {
  VisibilityIconMarket,
  Insights,
  Invite,
  Share,
  Expand,
  MarketSentimentDownArrow,
} from './Marketplaceicons';
import { poppins300, poppins400 } from 'theme/common.style';
import Arrow1 from 'assets/images/Arrow1.png';
import View from 'assets/images/View.png';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useState, useEffect } from 'react';
import InvitePopup from 'component/WelcomeBackScreen/InvitePopup';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { USER_TYPE } from 'constant/app.config';

dayjs.extend(utc);
dayjs.extend(timezone);

const ArrowSlider = ({ value = 70, duration = 2000 }) => {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));

  const containerRef = useRef(null);
  const arrowRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    const arrow = arrowRef.current;
    if (!container || !arrow) return;

    let animationFrameId = null;

    const animateArrow = () => {
      const startValue = 15;
      const target = Math.max(0, Math.min(100, value));
      const startTime = performance.now();

      const animate = (time) => {
        const elapsed = time - startTime;
        let progress = elapsed / duration;

        if (progress > 1) progress = 1;

        // Smooth easing
        const ease = 1 - Math.pow(1 - progress, 3);

        const currentPos = startValue + (target - startValue) * ease;
        arrow.style.left = `${currentPos}%`;

        if (progress < 1) {
          animationFrameId = requestAnimationFrame(animate);
        }
      };

      arrow.style.left = `${startValue}%`;

      setTimeout(() => {
        animationFrameId = requestAnimationFrame(animate);
      }, 100);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animateArrow();
          }
        });
      },
      {
        threshold: 0.6,
        rootMargin: '0px 0px -30px 0px',
      }
    );

    observer.observe(container);

    return () => {
      observer.disconnect();
      if (animationFrameId) cancelAnimationFrame(animationFrameId);
    };
  }, [value, duration]);

  return (
    <div
      ref={containerRef}
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '16px',
        background: '#F8F9FA',
        border: '1px solid #E5E7EB',
        borderRadius: '5px',
        padding: matchessm ? '10px 12px' : '15px 20px',
        width: 'fit-content',
      }}
    >
      <span
        style={{
          fontSize: '15px',
          fontWeight: 400,
          color: '#1F2937',
          whiteSpace: 'nowrap',
        }}
      >
        Market Sentiment
      </span>

      <Box marginTop={2}>
        <div
          style={{
            position: 'relative',
            width: matchessm ? 50 : 70,
            height: 10,
          }}
        >
          {/* Gradient Bar */}
          <div
            style={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              background: 'linear-gradient(to right, red, yellow, green)',
              borderRadius: '9999px',
            }}
          />

          {/* Arrow */}
          <div
            ref={arrowRef}
            style={{
              position: 'absolute',
              top: '-18px',
              left: '0%',
              transform: 'translateX(-50%)',
              fontSize: '20px',
              color: '#1F2937',
              zIndex: 2,
            }}
          >
            <MarketSentimentDownArrow />
          </div>
        </div>
      </Box>
    </div>
  );
};

const Commonfile = ({
  getBuyerIndividualValue,
  matchessm,
  openShare,
  matchesmd,
  handleClickOpen,
  matches500,
  handleFollowClick,
  matcheslgIsSti,
  isFollowLoading,
  sharedpage,
  openlogin,
  handleClose,
  setOpenlogin,
  matcheslgIsSticky,
  matcheslgup,
  highestOfferBox,
  setHideActivateTrade,
  setShowActivateTrade,
  setHighestOfferBox,
  tradeassist,
}) => {
  const history = useHistory();

  const handleBackToProperty = () => {
    if (!tradeassist) {
      if (sharedpage && !USER_TYPE) {
        setOpenlogin(!openlogin);
      } else {
        history.push('/dashboard');
      }
    } else {
      setHideActivateTrade(true);
      setShowActivateTrade(false);
    }
  };

  const [openInvite, setOpenInvite] = useState(false);

  const startedAt = getBuyerIndividualValue?.PropertyDetails?.startedAt;
  const viewsCount =
    getBuyerIndividualValue?.PropertyDetails?.propertyViewsCount;
  const viewText = viewsCount == 1 ? 'View' : 'Views';

  const [secondsLeft, setSecondsLeft] = useState(0);
  const [isUnderOneMinute, setIsUnderOneMinute] = useState(true);
  const [timeLabel, setTimeLabel] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      const nowSydney = dayjs().tz('Australia/Sydney');
      const startTime = dayjs.tz(
        startedAt,
        'YYYY-MM-DD HH:mm:ss',
        'Australia/Sydney'
      );
      const diffInSeconds = nowSydney.diff(startTime, 'second');
      const diffInMinutes = Math.floor(diffInSeconds / 60);

      if (diffInSeconds < 60) {
        setSecondsLeft(60 - diffInSeconds);
        setIsUnderOneMinute(true);
      } else {
        setIsUnderOneMinute(false);
        if (diffInMinutes < 60) {
          setTimeLabel(
            `${diffInMinutes} Minute${diffInMinutes > 1 ? 's' : ''}`
          );
        } else {
          const diffInHours = Math.floor(diffInMinutes / 60);
          setTimeLabel(`${diffInHours} Hour${diffInHours > 1 ? 's' : ''}`);
        }
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [startedAt]);

  return (
    <>
      {!matchessm && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginTop: '20px',
            marginBottom: '20px',
            width: '100%',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <img
              onClick={handleBackToProperty}
              src={Arrow1}
              style={{ marginRight: '10px', cursor: 'pointer', height: '10px' }}
            />
            <Typography
              onClick={handleBackToProperty}
              sx={{
                color: '#6C2AD2',
                ...poppins400,
                fontSize: '16px',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
              }}
            >
              Back to {tradeassist ? 'Property' : 'Dashboard'}
              {!matchessm && tradeassist && ' Details'}
            </Typography>
          </Box>
          {!matcheslgIsSticky && !matchessm && (
            <Box
              onClick={() => setHighestOfferBox(!highestOfferBox)}
              sx={{ cursor: 'pointer' }}
            >
              <Expand />
            </Box>
          )}
        </Box>
      )}
      <Grid
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          justifyItems: 'space-between',
          width: '100%',
          marginLeft: '0px',
          whiteSpace: 'nowrap',
        }}
      >
        {matchessm ? (
          <Typography
            sx={{
              display: 'flex',
              flexDirection: matchessm ? 'column' : 'row',
              fontFamily: 'Poppins !important',
              fontStyle: 'normal !important',
              fontWeight: '400 !important',
              fontSize: matchessm ? '14px' : '20px',
              color: '#666666',
            }}
          >
            Property ID:&nbsp;
            <Typography
              sx={{
                fontFamily: 'Poppins !important',
                fontStyle: 'normal !important',
                fontWeight: '400 !important',
                fontSize: matchessm ? '14px' : '20px',
                color: '#666666',
              }}
            >
              {
                getBuyerIndividualValue?.PropertyDetails?.property
                  ?.propertyUniqueId
              }
            </Typography>
          </Typography>
        ) : (
          <ArrowSlider value={70} width={280} duration={2000} />
        )}
        <Stack
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
          gap={matchessm ? '10px' : '15px'}
          direction={'row'}
        >
          {/* Follow Button */}
          {(USER_TYPE === 'Buyer' || !USER_TYPE) && (
            <div
              onClick={() => !isFollowLoading && handleFollowClick()}
              style={{ cursor: isFollowLoading ? 'not-allowed' : 'pointer' }}
            >
              <Grid
                onClick={() => {
                  if (sharedpage) {
                    setOpenlogin(!openlogin);
                  }
                }}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  border: '1px solid #DFDFDF',
                  borderRadius: '8px',
                  p: !matchesmd ? '10px 14px' : '10px 10px',
                  gap: '8px',
                  background:
                    getBuyerIndividualValue?.PropertyDetails?.isFollowed > 0
                      ? '#6C2AD2'
                      : '',
                  opacity: isFollowLoading ? 0.5 : 1,
                }}
              >
                {getBuyerIndividualValue?.PropertyDetails?.isFollowed == 0 ? (
                  <Typography
                    sx={{
                      width: '20px',
                      height: '20px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <VisibilityIconMarket color={'#666666'} />
                  </Typography>
                ) : (
                  <Typography
                    sx={{
                      width: '20px',
                      height: '20px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <VisibilityIconMarket color={'white'} />
                  </Typography>
                )}

                {!matchesmd && (
                  <Typography
                    sx={{
                      ...poppins300,
                      fontSize: '20px',
                      color:
                        getBuyerIndividualValue?.PropertyDetails?.isFollowed > 0
                          ? 'White'
                          : '#666666',
                    }}
                  >
                    {parseInt(
                      getBuyerIndividualValue?.PropertyDetails?.isFollowed
                    ) > 0
                      ? 'Following'
                      : 'Follow'}
                  </Typography>
                )}
              </Grid>
            </div>
          )}
          {/* Share Button */}
          <Grid
            onClick={handleClickOpen}
            sx={{
              display: 'flex',
              alignItems: 'center',
              border: '1px solid #DFDFDF',
              borderRadius: '8px',
              p: !matchesmd ? '10px 14px' : '10px 10px',
              gap: '8px',
              cursor: 'pointer',
            }}
          >
            <Typography
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '20px',
                height: '20px',
              }}
            >
              <Share />
            </Typography>

            {!matchesmd && (
              <Typography
                sx={{ ...poppins300, fontSize: '20px', color: '#666666' }}
              >
                Share
              </Typography>
            )}
          </Grid>

          {/* Invite Button */}
          {(USER_TYPE === 'Buyer' || !USER_TYPE) && (
            <Grid
              onClick={() => {
                if (sharedpage) {
                  setOpenlogin(!openlogin);
                } else {
                  setOpenInvite(!openInvite);
                }
              }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                border: '1px solid #DFDFDF',
                borderRadius: '8px',
                p: !matchesmd ? '10px 14px' : '10px 10px',
                gap: '5px',
                background: openInvite
                  ? 'linear-gradient(#6C2AD2 0%, #75B8F8 100%)'
                  : 'transparent',
                backgroundColor: 'transparent',
                cursor: 'pointer',
              }}
            >
              <Typography sx={{ width: '20px', height: '20px' }}>
                <Invite />
              </Typography>

              {!matchesmd && (
                <Typography
                  sx={{
                    ...poppins300,
                    fontSize: '20px',
                    color: '#666666',
                    cursor: 'pointer',
                  }}
                >
                  Invite
                </Typography>
              )}
            </Grid>
          )}
          {openInvite && (
            <InvitePopup
              openInvite={openInvite}
              setOpenInvite={setOpenInvite}
            />
          )}
          {openShare && <SharePopup open={openShare} onClose={handleClose} />}
          {/* Insights Button */}
          {(USER_TYPE === 'Buyer' || !USER_TYPE) && (
            <Grid
              onClick={() => {
                if (sharedpage) {
                  setOpenlogin(!openlogin);
                }
              }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                border: '1px solid #DFDFDF',
                borderRadius: '8px',
                p: !matchesmd ? '10px 14px' : '10px 10px',
                gap: '8px',
              }}
            >
              <Typography sx={{ width: '20px', height: '20px' }}>
                <Insights />
              </Typography>

              {!matchesmd && (
                <Typography
                  sx={{ ...poppins300, fontSize: '20px', color: '#666666' }}
                >
                  Insights
                </Typography>
              )}
            </Grid>
          )}
        </Stack>
      </Grid>

      {matchessm && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginTop: '20px',
            width: '100%',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <img
              onClick={handleBackToProperty}
              src={Arrow1}
              style={{ marginRight: '10px', cursor: 'pointer' }}
            />
            <Typography
              onClick={handleBackToProperty}
              sx={{
                color: '#6C2AD2',
                ...poppins400,
                fontSize: '16px',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
              }}
            >
              Back to {tradeassist ? 'Property' : 'Dashboard'}
              {!matchessm && ' Details'}
            </Typography>
          </Box>
          {!matcheslgIsSticky && !matchessm && (
            <Box
              onClick={() => setHighestOfferBox(!highestOfferBox)}
              sx={{ cursor: 'pointer' }}
            >
              <Expand />
            </Box>
          )}
        </Box>
      )}

      <Grid
        item
        sx={{
          display: 'flex',
          flexDirection: matchessm ? 'column' : 'row',
          justifyContent: 'space-between',
          alignItems: matchessm ? 'flex-start' : 'center',
          gap: matchessm ? '15px' : '20px',
          width: '100%',
          marginTop: '25px',
        }}
      >
        <Typography sx={{ display: 'flex', alignItems: 'center' }}>
          <img
            src={View}
            alt="View"
            style={{
              width: '21px',
              height: '21px',
            }}
          />
          <Typography
            sx={{
              fontFamily: 'Poppins !important',
              fontStyle: 'normal !important',
              fontWeight: '400 !important',
              fontSize: '16px',
              paddingLeft: matchessm ? '5px' : '15px',
              color: '#ED0B0B',
              whiteSpace: 'nowrap',
            }}
          >
            {viewsCount} {viewText} in{' '}
            {isUnderOneMinute
              ? `${secondsLeft} Second${secondsLeft != 1 ? 's' : ''}`
              : timeLabel}
          </Typography>
        </Typography>
        {matchessm ? (
          <Typography
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
            }}
          >
            <ArrowSlider />
          </Typography>
        ) : (
          <Typography
            sx={{
              display: 'flex',
              flexDirection: matchessm ? 'column' : 'row',
              fontFamily: 'Poppins !important',
              fontStyle: 'normal !important',
              fontWeight: '400 !important',
              fontSize: matchessm ? '14px' : '20px',
              color: '#666666',
            }}
          >
            Property ID: &nbsp;
            <Typography
              sx={{
                fontFamily: 'Poppins !important',
                fontStyle: 'normal !important',
                fontWeight: '400 !important',
                fontSize: matchessm ? '14px' : '20px',
                color: '#666666',
              }}
            >
              {
                getBuyerIndividualValue?.PropertyDetails?.property
                  ?.propertyUniqueId
              }
            </Typography>
          </Typography>
        )}
      </Grid>
    </>
  );
};

export default Commonfile;
